import React, { useState } from "react";
import { FaGift } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import { RiArrowRightSLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";  // Import useNavigate


const Cart2 = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();  // Initialize useNavigate

  // Function to handle checkout button click
  const handleCheckout = () => {
    navigate("/checkout2");  // Redirect to the checkout page
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      {/* Open Sidebar Button */}
      <button
        className="bg-blue-600 text-white px-4 py-2 rounded-md"
        onClick={() => setIsOpen(true)}
      >
        Open Cart
      </button>

      {/* Right Sidebar */}
      <div
        className={` overflow-hidden z-50 fixed top-0 right-0 h-full w-96 bg-white shadow-lg transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300 ease-in-out p-4 overflow-y-auto`}
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold">Bag</h2>
          <button
            className="text-gray-500 text-xl"
            onClick={() => setIsOpen(false)}
          >
            &times;
          </button>
        </div>

        {/* Product Info */}
        <div className="flex gap-8 border-b pb-4">
          <img
            src="https://adn-static1.nykaa.com/nykdesignstudio-images/pub/media/catalog/product/5/0/508c0bbRABYA3102-SABASOFTBLUE_1.jpg?rnd=20200526195200&tr=w-512"
            alt="Product"
            className="w-24 h-40 object-cover rounded"
          />
          <div>
            <h3 className="text-sm font-medium">Forever New</h3>
            <p className="text-xs text-gray-500">Maggie Fashion Trench...</p>
            <p className="text-xs text-gray-500">
              Size 8 - Qty 1 - <span className="text-red-500">5 left</span>
            </p>
            <p className="text-xs text-green-500">7 Day Return</p>
          </div>
        </div>

        <div className="flex flex-col items-end space-y-0 border-b border-gray-300 p-1">
          <p className="text-sm font-semibold mt-1">
            You Pay <span className="text-blue-600">₹7,350</span>
          </p>
          <p className="text-xs text-green-600 mb-3">
            30% off <span className="line-through text-gray-400">₹10,500</span>
          </p>
        </div>

        {/* Coupons */}
        <div className="flex justify-between items-center py-4 border-b">
          {/* Left side: Gift icon */}
          <FaGift className="text-xl" />

          {/* Center: p tag and button */}
          <div className="flex flex-col items-start flex-grow ml-5">
            <p className="text-md font-medium">Coupons</p>
            <button className="text-red-600 text-sm">
              Apply Coupons and save extra
            </button>
          </div>

          {/* Right side: Arrow icon */}
          <RiArrowRightSLine className="text-4xl text-gray-600" />
        </div>

        {/* Price Summary */}
        <div className="mt-4 bg-white p-3 rounded-lg border-1 border-gray-500">
          <h3 className="text-sm font-semibold mb-2">Price Summary</h3>
          <div className="flex justify-between text-sm py-1">
            <p>Bag Total</p>
            <p>₹10,500</p>
          </div>
          <div className="flex justify-between text-sm text-green-600 py-1">
            <p>Discount on MRP</p>
            <p>-₹3,150</p>
          </div>
          <div className="flex justify-between text-sm py-1">
            <p>Sub Total</p>
            <p>₹7,350</p>
          </div>
          <div className="flex justify-between text-sm py-1">
            <p>Convenience Charges</p>
            <p>₹29</p>
          </div>
          <div className="flex justify-between font-semibold text-md mt-2">
            <p>You Pay</p>
            <p>₹7,379</p>
          </div>
          <div className="bg-green-100 border-1 border-gray-300">
            <p className="text-green-600 text-xs m-0 p-1">
              🎉 Yay! You are saving ₹3,150.
            </p>
          </div>
        </div>

        <div className="bg-gray-100 p-1 flex mt-3">
          <div className="flex flex-col items-center">
            <img
              src="https://images-static.nykaa.com/fashion-images/pub/media/nf-secure-payments.svg?tr=w-64"
              className="w-14 h-14"
              alt="Secure Payments"
            />
            <h1 className="text-xs mt-0 mb-0">Secure Payments</h1>
          </div>
          <div className="flex flex-col items-center mx-3">
            <img
              src="https://images-static.nykaa.com/fashion-images/pub/media/nf-easy-returns.svg?tr=w-64"
              className="w-14 h-14"
              alt="Easy Returns"
            />
            <h1 className="text-xs mt-0 mb-0">Easy Returns</h1>
          </div>
          <div className="flex flex-col items-center">
            <img
              src="https://images-static.nykaa.com/fashion-images/pub/media/nf-genuine-products.svg?tr=w-64"
              className="w-14 h-14"
              alt="Genuine Products"
            />
            <h1 className="text-xs mt-0 mb-0">Genuine Products</h1>
          </div>
        </div>

        {/* Footer fixed at the bottom of the sidebar */}
        <div className="absolute bottom-0 left-0 w-full bg-gray-100 p-3 flex justify-between items-center shadow-lg">
          {/* Left side: Price and View Details link */}
          <div className="flex items-center space-x-4">
            <p className="text-lg font-semibold">₹7,379</p>
            <a href="#" className="text-blue-600 text-sm">
              View Details
            </a>
          </div>

          {/* Right side: Button */}
          <button className="bg-blue-600 text-white px-6 py-2 rounded-md"
          onClick={handleCheckout}>
            Checkout
          </button>
        </div>
        
      </div>

      {/* Overlay when sidebar is open */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default Cart2;
